import React from "react";

const ArrowLeftIcon = ({ size = 13, color = "#735FE3", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.83333 7.14583L6.91667 11.2292C7.08333 11.3958 7.16319 11.5903 7.15625 11.8125C7.14931 12.0347 7.0625 12.2292 6.89583 12.3958C6.72917 12.5486 6.53472 12.6285 6.3125 12.6354C6.09028 12.6424 5.89583 12.5625 5.72917 12.3958L0.229167 6.89583C0.145833 6.8125 0.0868056 6.72222 0.0520833 6.625C0.0173611 6.52778 0 6.42361 0 6.3125C0 6.20139 0.0173611 6.09722 0.0520833 6C0.0868056 5.90278 0.145833 5.8125 0.229167 5.72917L5.72917 0.229167C5.88194 0.0763889 6.07292 0 6.30208 0C6.53125 0 6.72917 0.0763889 6.89583 0.229167C7.0625 0.395833 7.14583 0.59375 7.14583 0.822917C7.14583 1.05208 7.0625 1.25 6.89583 1.41667L2.83333 5.47917H12.1458C12.3819 5.47917 12.5799 5.55903 12.7396 5.71875C12.8993 5.87847 12.9792 6.07639 12.9792 6.3125C12.9792 6.54861 12.8993 6.74653 12.7396 6.90625C12.5799 7.06597 12.3819 7.14583 12.1458 7.14583H2.83333Z"
      fill={color}
    />
  </svg>
);

export default ArrowLeftIcon;
